import { useTranslations } from 'next-intl'

export const ContainerPriceTable = () => {
  const t = useTranslations()
  const containers = t.raw('BorettslagContainerOffer.containers') as {
    title: string
    options: { label: string; price: string }[]
    disclaimer: string
  }[]

  return (
    <div className="my-4 space-y-4 rounded-xl border border-black bg-white px-4 py-2">
      <details>
        <summary className="cursor-pointer select-none">
          <h2 className="inline text-xl font-semibold">{t('BorettslagContainerOffer.title')}</h2>
        </summary>
        {containers.map((container, i) => (
          <div key={i} className="mt-6">
            <table className="w-full text-sm sm:text-base [&_td]:border [&_td]:leading-7">
              <thead>
                <tr>
                  <td colSpan={2} className="bg-blue-200 text-xl font-semibold">
                    {container.title}
                  </td>
                </tr>
              </thead>
              <tbody>
                {container.options.map((option, j) => (
                  <tr key={j}>
                    <td>{option.label}</td>
                    <td>{option.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-2 text-sm text-gray-600">{container.disclaimer}</p>
          </div>
        ))}
        <p className="mt-4 text-sm font-medium">{t('BorettslagContainerOffer.priceNote')}</p>
      </details>
    </div>
  )
}
